

























































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VcNavArrow from "@/components/form_components/VcNavArrow.vue";
import { fetchUnits } from "@/components/common/UnitRuangPicker.vue";
import LaporanRekapPersetujuanPasien from "@/services/LaporanRekapPersetujuanPasien";
import BerkasRmService from "@/services/BerkasRmService";
import ErrorAlert from "@/utility/ErrorAlert";
import {
  RekapPersetujuanDokterOpsi,
  RekapPersetujuanFilter,
  RekapPersetujuanFilterForm,
  RekapPersetujuanKeputusanFilter,
  RekapPersetujuanMeta,
  RekapPersetujuanOpsi,
  RekapPersetujuanPilihan,
  RekapPersetujuanRentang,
  RekapPersetujuanRingkasan,
  RekapPersetujuanRow
} from "@/types/rekapPersetujuan";

const FORMAT = "YYYY-MM-DD";
const FORMAT_TAMPIL = "DD/MM/YYYY";
const MAX_PERIODE_HARI = 92;
const MAX_PDF_BARIS = 500;
const SEMUA_DOKTER = 0;

interface BarisTabel extends RekapPersetujuanRow {
  kunci: string;
}

function filterAwal(): RekapPersetujuanFilterForm {
  return {
    q: "",
    keputusan: "semua",
    jenis_form: "",
    kelompok: "",
    unit: "",
    dokter: SEMUA_DOKTER
  };
}

function rentangAwal(): RekapPersetujuanRentang {
  const hariIni = moment().format(FORMAT);

  return { start: hariIni, end: hariIni };
}

@Component({
  components: { VcNavArrow }
})
export default class LaporanRekapPersetujuanPasienPage extends Vue {
  filter: RekapPersetujuanFilterForm = filterAwal();
  rentang: RekapPersetujuanRentang = rentangAwal();
  filterTermuat: RekapPersetujuanFilter | null = null;

  hariIni = moment().format(FORMAT);
  batasTanggal = moment()
    .endOf("day")
    .toDate();

  opsi: RekapPersetujuanOpsi | null = null;
  dokterOptions: RekapPersetujuanDokterOpsi[] = [];
  loadingDokter = false;
  units: RekapPersetujuanPilihan[] = [];
  loadingUnit = false;

  rows: BarisTabel[] = [];
  meta: RekapPersetujuanMeta | null = null;
  ringkasan: RekapPersetujuanRingkasan | null = null;
  perHalaman = 10;

  loading = false;
  loadingPdf = false;
  loadingExcel = false;

  readonly modelConfigTanggal = { type: "string", mask: FORMAT };

  readonly keputusanOptions: {
    text: string;
    value: RekapPersetujuanKeputusanFilter;
  }[] = [
    { text: "Semua Status Keputusan [Default]", value: "semua" },
    { text: "Setuju", value: "setuju" },
    { text: "Tolak", value: "tolak" }
  ];

  readonly headers = [
    { text: "No", value: "no", width: 36, align: "center" },
    { text: "No. RM", value: "no_rm", width: 76 },
    { text: "No. Register", value: "register_id", width: 88 },
    { text: "Nama Pasien", value: "nama_pasien" },
    { text: "JK / Umur", value: "jk_umur", width: 64 },
    { text: "Ruang / Unit", value: "unit_nama" },
    { text: "Tgl / Jam", value: "waktu", width: 78 },
    { text: "Jenis Form", value: "jenis_form" },
    { text: "Tindakan / Layanan", value: "tindakan" },
    { text: "Penanggung Jawab", value: "penanggung_jawab" },
    { text: "DPJP / Dokter / Petugas", value: "dokter" },
    { text: "Status", value: "keputusan", width: 84, align: "center" },
    { text: "Keterangan / Alasan", value: "keterangan" },
    { text: "Status Berkas", value: "status", width: 72, align: "center" },
    { text: "Berkas", value: "berkas", width: 64, align: "center" }
  ];

  get labelRentang(): string {
    if (!this.rentang || !this.rentang.start || !this.rentang.end) {
      return "";
    }

    return `${this.tampilTanggal(this.rentang.start)} s/d ${this.tampilTanggal(
      this.rentang.end
    )}`;
  }

  get maxPeriodeHari(): number {
    return this.opsi ? this.opsi.max_periode_hari : MAX_PERIODE_HARI;
  }

  get alasanPeriode(): string | null {
    if (!this.rentang || !this.rentang.start || !this.rentang.end) {
      return "Rentang tanggal wajib diisi.";
    }

    const hari = moment(this.rentang.end, FORMAT).diff(
      moment(this.rentang.start, FORMAT),
      "days"
    );

    if (hari < 0) {
      return "Tanggal akhir tidak boleh sebelum tanggal awal.";
    }

    if (hari > this.maxPeriodeHari) {
      return `Rentang maksimal ${this.maxPeriodeHari} hari (saat ini ${hari + 1} hari).`;
    }

    return null;
  }

  get filterAktif(): RekapPersetujuanFilter {
    const f = this.filter;

    return {
      tgl_start: this.rentang.start,
      tgl_end: this.rentang.end,
      q: f.q || "",
      keputusan: f.keputusan,
      jenis_form: f.jenis_form ? [f.jenis_form] : [],
      kelompok: f.kelompok ? [f.kelompok] : [],
      unit: f.unit ? [f.unit] : [],
      dokter: f.dokter || null
    };
  }

  get kelompokOptions(): RekapPersetujuanPilihan[] {
    return [
      { text: "Semua Jenis Tindakan", value: "" },
      ...(this.opsi ? this.opsi.kelompok : [])
    ];
  }

  get jenisFormOptions(): RekapPersetujuanPilihan[] {
    const semua = this.opsi ? this.opsi.jenis_form : [];
    const kelompok = this.filter.kelompok;

    return [
      { text: "Semua Jenis Form [Default]", value: "" },
      ...(kelompok ? semua.filter(item => item.kelompok === kelompok) : semua)
    ];
  }

  get unitOptions(): RekapPersetujuanPilihan[] {
    return [{ text: "Semua Unit / Ruangan [Default]", value: "" }, ...this.units];
  }

  get dokterPilihan(): RekapPersetujuanDokterOpsi[] {
    return [
      { user_id: SEMUA_DOKTER, nama: "Semua Dokter DPJP [Default]" },
      ...this.dokterOptions
    ];
  }

  get perHalamanOptions(): number[] {
    return this.opsi ? this.opsi.per_halaman : [10, 25, 50, 100];
  }

  get maxPdfBaris(): number {
    return this.opsi ? this.opsi.max_pdf_baris : MAX_PDF_BARIS;
  }

  get alasanPdfMati(): string | null {
    if (!this.filterTermuat || !this.meta) {
      return "Tampilkan data terlebih dahulu.";
    }

    if (this.meta.total > this.maxPdfBaris) {
      return `Cetak PDF maksimal ${this.maxPdfBaris} baris (hasil saat ini ${this.meta.total}). Persempit filter atau gunakan Download Excel.`;
    }

    return null;
  }

  get tiles() {
    const r = this.ringkasan;

    return [
      {
        label: "TOTAL BERKAS",
        nilai: r ? r.total : 0,
        icon: "mdi-file-document",
        warna: "blue darken-2",
        latar: "blue lighten-5",
        teks: "grey--text text--darken-4"
      },
      {
        label: "DISETUJUI",
        nilai: r ? r.setuju : 0,
        icon: "mdi-check-circle",
        warna: "green darken-1",
        latar: "green lighten-5",
        teks: "green--text text--darken-2"
      },
      {
        label: "DITOLAK",
        nilai: r ? r.tolak : 0,
        icon: "mdi-close-circle",
        warna: "red darken-1",
        latar: "red lighten-5",
        teks: "red--text text--darken-1"
      },
      {
        label: "DRAFT",
        nilai: r ? r.draft : 0,
        icon: "mdi-history",
        warna: "orange darken-2",
        latar: "orange lighten-5",
        teks: "orange--text text--darken-2"
      }
    ];
  }

  get labelFilterTermuat(): string {
    const f = this.filterTermuat;

    if (!f) {
      return "belum ditampilkan";
    }

    const hariIni = f.tgl_start === this.hariIni && f.tgl_end === this.hariIni;
    const periode = hariIni
      ? "Hari ini"
      : f.tgl_start === f.tgl_end
      ? this.tampilTanggal(f.tgl_start)
      : `${this.tampilTanggal(f.tgl_start)} s/d ${this.tampilTanggal(f.tgl_end)}`;
    const unit = f.unit.length
      ? this.units.find(u => u.value === f.unit[0])
      : null;

    const bagian = [
      periode,
      unit ? unit.text : "Semua Unit",
      f.keputusan === "semua"
        ? "Semua Status"
        : f.keputusan === "setuju"
        ? "Setuju"
        : "Tolak"
    ];

    const tambahan: string[] = [];

    if (f.jenis_form.length) {
      const jenis = this.jenisFormOptions.find(j => j.value === f.jenis_form[0]);
      tambahan.push(jenis && jenis.text ? jenis.text : "Jenis form dipilih");
    }
    if (f.kelompok.length) {
      const kelompok = this.kelompokOptions.find(k => k.value === f.kelompok[0]);
      tambahan.push(kelompok && kelompok.text ? kelompok.text : "Klasifikasi dipilih");
    }
    if (f.dokter) {
      const dokter = this.dokterOptions.find(d => d.user_id === f.dokter);
      tambahan.push(dokter ? dokter.nama : "Dokter dipilih");
    }
    if (f.q) {
      tambahan.push(`Cari: "${f.q}"`);
    }

    const semuaDefault = hariIni && !unit && f.keputusan === "semua" && !tambahan.length;

    return (semuaDefault ? "Default: " : "") + bagian.concat(tambahan).join(", ");
  }

  async mounted() {
    this.muatDokter();
    this.muatUnit();

    try {
      this.opsi = await LaporanRekapPersetujuanPasien.opsi();
    } catch (e) {
      return;
    }

    await this.tampilkan();
  }

  async muatDokter() {
    this.loadingDokter = true;

    try {
      this.dokterOptions = await LaporanRekapPersetujuanPasien.dokter();
    } catch (e) {
      this.dokterOptions = [];
    } finally {
      this.loadingDokter = false;
    }
  }

  async muatUnit() {
    this.loadingUnit = true;

    try {
      const units = await fetchUnits();
      this.units = units.map(u => ({ text: u.nama, value: u.id }));
    } catch (e) {
      this.units = [];
    } finally {
      this.loadingUnit = false;
    }
  }

  sesuaikanJenisForm() {
    const tersedia = this.jenisFormOptions.map(item => item.value);

    if (tersedia.indexOf(this.filter.jenis_form) < 0) {
      this.filter.jenis_form = "";
    }
  }

  async tampilkan() {
    if (this.alasanPeriode) {
      return;
    }

    this.sesuaikanJenisForm();

    await this.muat({ ...this.filterAktif }, 1);
  }

  async muat(filter: RekapPersetujuanFilter, halaman: number) {
    this.loading = true;

    try {
      const res = await LaporanRekapPersetujuanPasien.preview(
        filter,
        halaman,
        this.perHalaman
      );
      this.filterTermuat = filter;
      this.rows = res.data.map(row => ({
        ...row,
        kunci: `${row.sumber}-${row.id}`
      }));
      this.meta = res.meta;
      this.ringkasan = res.ringkasan;
    } catch (e) {
      // Pesan galat sudah ditampilkan ErrorAlert di service.
    } finally {
      this.loading = false;
    }
  }

  gantiHalaman(halaman: number) {
    if (this.filterTermuat) {
      this.muat(this.filterTermuat, halaman);
    }
  }

  gantiPerHalaman() {
    if (this.filterTermuat) {
      this.muat(this.filterTermuat, 1);
    }
  }

  reset() {
    this.filter = filterAwal();
    this.rentang = rentangAwal();
    this.tampilkan();
  }

  async cetakPdf() {
    if (!this.filterTermuat) {
      return;
    }

    this.loadingPdf = true;

    try {
      await LaporanRekapPersetujuanPasien.openPdf(this.filterTermuat);
    } catch (e) {
      // ditangani service
    } finally {
      this.loadingPdf = false;
    }
  }

  async unduhExcel() {
    if (!this.filterTermuat) {
      return;
    }

    this.loadingExcel = true;

    try {
      await LaporanRekapPersetujuanPasien.downloadExcel(this.filterTermuat);
    } catch (e) {
      // ditangani service
    } finally {
      this.loadingExcel = false;
    }
  }

  bukaFormPdf(row: RekapPersetujuanRow) {
    if (row.pdf_path) {
      LaporanRekapPersetujuanPasien.openFormPdf(row.pdf_path);
    }
  }

  async bukaBerkas(id: number) {
    try {
      await BerkasRmService.openFile(id);
    } catch (e) {
      ErrorAlert.showErrorAlert(e);
    }
  }

  tooltipBerkas(row: RekapPersetujuanRow): string {
    if (!row.berkas_didukung) {
      return "Form ini tidak memiliki berkas unggahan";
    }

    return row.berkas.length ? "Lihat Berkas Upload" : "Belum ada berkas diunggah";
  }

  jkUmur(row: RekapPersetujuanRow): string {
    const bagian = [row.jk, row.umur].filter(v => !!v && v !== "-");

    return bagian.length ? bagian.join(" / ") : "-";
  }

  warnaKeputusan(row: RekapPersetujuanRow): string {
    if (row.keputusan === "setuju") {
      return "green darken-1";
    }

    return row.keputusan === "tolak" ? "red darken-1" : "grey";
  }

  ikonKeputusan(row: RekapPersetujuanRow): string {
    if (row.keputusan === "setuju") {
      return "mdi-check";
    }

    return row.keputusan === "tolak" ? "mdi-close" : "mdi-help";
  }

  private tampilTanggal(nilai: string): string {
    return moment(nilai, FORMAT).format(FORMAT_TAMPIL);
  }
}
